import { render, staticRenderFns } from "./virtualOrder.vue?vue&type=template&id=45563531&scoped=true&"
import script from "./virtualOrder.vue?vue&type=script&lang=js&"
export * from "./virtualOrder.vue?vue&type=script&lang=js&"
import style0 from "./virtualOrder.vue?vue&type=style&index=0&id=45563531&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45563531",
  null
  
)

export default component.exports